class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const instaSwiper = new Swiper(".c-swiper-insta", {
      slidesPerView: 'auto',
      spaceBetween: 6,
      speed: 13000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
      },
      loop: true,
      breakpoints: {
        768: {
          spaceBetween: 20,
        }
      },
    });

    const messageSwiper = new Swiper('.c-message-swiper', {
      slidesPerView: 1,
      loop: true,
      speed: 600,
    
      navigation: {
        nextEl: '.c-swiper-message-next',
        prevEl: '.c-swiper-message-prev',
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    
      allowTouchMove: true,
    });
    

    const totalSlides =
    messageSwiper.slides.length - messageSwiper.loopedSlides * 2;
    document.querySelector('.c-swiper-message-total').textContent = String(totalSlides).padStart(2, '0');
  

    messageSwiper.on('slideChange', () => {
      const index = messageSwiper.realIndex + 1;
      document.querySelector('.c-swiper-message-current').textContent =
        String(index).padStart(2, '0');
    });


    $('.js-acc-content').hide();
    $('.js-acc-trigger').click(function() {
      $(this).next().slideToggle();
      $(this).find('.ic-plus').toggleClass('is-active');
    })

    var mvSwiper = new Swiper(".c-mv-swiper", {
      slidesPerView: 1,
      loop: true,
      speed: 2000,
      effect: "fade",
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
    
  }
}
